const BiologicalScience = () => {
    return (
        <>
            <div className="about-ed-wrapper-impact">
                <h2 className="about-ed-heading-impact">Biological Science</h2>
                <div className="about-ed-block-impact">
                    <div className="about-ed-content-impact">
                        <ul className="journal-ul-impact">
                            <li className="journal-li-impact">Biochemistry</li>
                            <li className="journal-li-impact">Biotechnology</li>
                            <li className="journal-li-impact">Genetics</li>
                            <li className="journal-li-impact">Microbiology</li>
                            <li className="journal-li-impact">Molecular Biology</li>
                            <li className="journal-li-impact">Immunology</li>
                            <li className="journal-li-impact">Biostatistics</li>
                            <li className="journal-li-impact">Botany, Zoology</li>
                            <li className="journal-li-impact">Cytology</li>
                            <li className="journal-li-impact">Poultry Science</li>
                            <li className="journal-li-impact">Fishery Science</li>
                            <li className="journal-li-impact">Marine Biology</li>
                            <li className="journal-li-impact">Wildlife Biology</li>
                            <li className="journal-li-impact">Cell Biology</li>
                            <li className="journal-li-impact">Environmental Sciences</li>
                            <li className="journal-li-impact">Ecology & Environmental Biology</li>
                            <li className="journal-li-impact">Veterinary Science</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BiologicalScience;
